import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack, Tooltip, Typography } from '@mui/material';
import { Eye, Tag } from 'mdi-material-ui';
const options = [
    {
        source: 'poe',
        color: '#22A06B',
        icon: _jsx(Tag, { sx: { fontSize: '14px', color: '#22A06B' } }),
        bgColor: '#E6FAF1'
    },
    {
        source: 'tag-creative',
        color: '#8D2CA8',
        icon: _jsx(Tag, { sx: { fontSize: '14px', color: '#8D2CA8' } }),
        bgColor: '#F8E3FE'
    },
    {
        source: 'all-schedules' || 'mop' || 'all-po' || 'po-mop' || 'bulk-schedule',
        color: 'primary.main',
        icon: _jsx(Eye, { color: "primary", sx: { fontSize: '14px' } }),
        bgColor: 'brand.light'
    }
];
const MediaChip = ({ schedule, source }) => {
    const selectedOption = schedule.type === 'artwork'
        ? options[1]
        : schedule.type === 'poe'
            ? options[0]
            : options[2];
    return (_jsx(_Fragment, { children: _jsx(Stack, Object.assign({ direction: "row", alignItems: "center", gap: 2 }, { children: _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", gap: 1, sx: {
                    backgroundColor: selectedOption.bgColor,
                    borderRadius: '8px',
                    padding: '3px 3px',
                    marginTop: '6px',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    maxWidth: 142,
                    // maxWidth: source === 'all-po' || source === 'po-mop' ? 140 : 166
                } }, { children: [selectedOption.icon, _jsx(Tooltip, Object.assign({ title: schedule.name, placement: "right" }, { children: _jsxs(Typography, Object.assign({ variant: "h6", sx: {
                                color: selectedOption.color,
                            }, noWrap: true }, { children: [schedule.units, " ", schedule.name] })) }))] })) })) }));
};
export default MediaChip;
